import type { I18n } from '@change-corgi/core/i18n';
import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { PrefetchableComponentType, PrefetchContextData, PrefetchUserContextData } from 'src/shared/prefetch';

export type Options = {
	prefetchedData?: PrefetchContextData;
	prefetchedUserData?: PrefetchUserContextData;
	i18n?: I18n | UtilityContext['i18n'];
};

export function getPageTitle(component: PrefetchableComponentType | undefined, options: Options): string {
	if (!options.i18n) {
		return getDefaultPageTitle(options);
	}
	if (!component || !component.prefetchName || !component.pageTitle) {
		return getDefaultPageTitle(options);
	}
	return (
		component.pageTitle({
			i18n: options.i18n,
			prefetchedData: options.prefetchedData?.[component.prefetchName],
			prefetchedUserData: options.prefetchedUserData?.[component.prefetchName],
			fromTemplate,
		}) || getDefaultPageTitle(options)
	);
}

function getDefaultPageTitle(options: Options) {
	if (!options.i18n) {
		return 'Change.org';
	}
	return `Change.org · ${options.i18n.translate('fe.pages.home.title')}`;
}

function fromTemplate(title: string) {
	return `${title} · Change.org`;
}
